export default __webpack_public_path__ + "static/media/profile-view-activee.2bb66fdd.svg";